export const backToTopButtonId = 'back-to-top-button';
